
    var riot = require('riot')
    riot.tag2('feature-feedback-widget', '<div class="{\'message-bar\': true, \'hidden-print\': true, \'message-bar-standalone\': opts.standalone === true}" data-feature-feedback-link-container> <span class="message-bar-icon">i</span> <span class="message-bar-text"> <button class="message-bar-action link-white unbutton" data-feature-feedback-link data-feature-feedback-key="{opts.key}" data-feature-feedback-title="{opts.title}" data-feature-feedback-subtitle="{opts.subtitle}" data-feature-feedback-likelabel="{opts.likelabel}" data-feature-feedback-dislikelabel="{opts.dislikelabel}">{opts.linktext}</button> </span> </div>', '', '', function(opts) {
});
    
  


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/tags/feature-feedback-widget.riot.html